module.exports = __webpack_public_path__ + "static/media/energy.5a7173e6.svg";